import React, { useEffect, useRef, useState } from "react";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import "swiper/css"; // Import Swiper styles
import { Swiper, SwiperSlide } from "swiper/react";
import L from "../../src/images/homepage/testimonials/L.png";
// import profile from "../../src/images/homepage/testimonials/profile.png";
import quotes from '../../src/images/testimonials/quotes.png';

// Sample testimonial data with 3 items
// const testimonials = [
//   {
//     quote:
//       "Working with your design team was an absolute pleasure. The attention to detail and creativity exceeded my expectations. Thank you for making my home beautiful!",
//     name: "Sophie Carter",
//     location: "New York, USA",
//     profileImage: profile,
//   },
//   {
//     quote:
//       "Working with your design team was an absolute pleasure. The attention to detail and creativity exceeded my expectations. Thank you for making my home beautiful!",
//     name: "Michael Lee",
//     location: "Los Angeles, USA",
//     profileImage: profile,
//   },
//   {
//     quote:
//       "Working with your design team was an absolute pleasure. The attention to detail and creativity exceeded my expectations. Thank you for making my home beautiful!",
//     name: "Emily Johnson",
//     location: "San Francisco, USA",
//     profileImage: profile,
//   },
// ];

const TestimonialContents = ({ testimonialCards }) => {
  const [startIndex, setStartIndex] = useState(0);
  const [visibleTestimonials, setVisibleTestimonials] = useState([]);
  const swiperRef = useRef(null); // Create a reference for the Swiper component

  // Handle next button click
  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext(); // Move to the next slide
    }
  };

  // Handle previous button click
  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev(); // Move to the previous slide
    }
  };

  // Adjust visible testimonials based on screen width
  useEffect(() => {
    const updateVisibleTestimonials = () => {
      const isLargeScreen = window.innerWidth >= 1024;
      setVisibleTestimonials(
        isLargeScreen
          ? [
              testimonialCards[startIndex],
              testimonialCards[(startIndex + 1) % testimonialCards.length],
            ]
          : [testimonialCards[startIndex]]
      );
    };

    // Update on initial render
    updateVisibleTestimonials();

    // Recalculate when screen is resized
    window.addEventListener("resize", updateVisibleTestimonials);

    // Clean up listener on unmount
    return () => {
      window.removeEventListener("resize", updateVisibleTestimonials);
    };
  }, [startIndex]);

  return (
    <section className="w-full h-auto flex flex-col items-center bg-banner pb-8 relative border-none overflow-x-hidden">
      {/* L Image and Arrows */}
      <div className="absolute top-[-50px] left-44 lg:flex below-1300:top-[-70px] flex-col items-center pb-3 below-1300:scale-90 below-1079  above-1900:left-[570px] below-1490:left-[120px] below:1373:left-[0px] hidden">
        <img
          src={L}
          alt="L shape image"
          className="w-[500px] min-h-[300px] mb-4"
        />
      </div>

      {/* Arrow Buttons Positioned Below the "L" Image */}
      <div className="relative justify-center gap-5 mt-4 lg:mt-0 hidden lg:flex">
        <button
          onClick={handlePrev}
          className="p-2 bg-[#ADD143] rounded-lg px-4 py-4 lg:mx-0 lg:absolute lg:top-[500px] lg:right-[520px]"
        >
          <IoArrowBack size={24} />
        </button>
        <button
          onClick={handleNext}
          className="p-2 bg-[#ADD143] rounded-lg px-4 py-4 lg:mx-0 lg:absolute lg:top-[500px] lg:right-[440px]"
        >
          <IoArrowForward size={24} />
        </button>
      </div>

      {/* Testimonial Cards */}
      <ul className="flex flex-col lg:flex-row max-w-[450px] lg:max-w-[850px] lg:gap-0 items-center mt-8 lg:mt-2 list-none p-0 transition-all duration-500 ease-in-out ml-12">
        <Swiper
          ref={swiperRef} // Attach the swiper reference
          spaceBetween={1}
          slidesPerView={2}
          loop={true}
          speed={500} // Animation duration (ms) for smooth transition
          effect="fade" // Optional: 'fade' effect for smoother look
          fadeEffect={{ crossFade: true }} // Smooth fade transitions
          onSlideChange={(swiper) => setStartIndex(swiper.activeIndex)}
          className="mt-8 lg:mt-24"
        >
          {testimonialCards.map((testimonial, index) => (
            <SwiperSlide key={testimonial.id || index}>
              <li className="bg-[#1F1F1F] rounded-xl p-8 h-[600px] max-w-[380px] lg:h-[600px] flex flex-col justify-between items-start max-w-[400px] lg:w-[400px] transition-all duration-500 ease-in-out transform">
              <div className="text-[#ADD143] mt-5">
              <img
                src={quotes}
                alt="Quote symbol"
                className="w-[50px] "
              />
            </div>
            <div className="max-w-[300px] mt-[30px] lg:mt-[40px]">
              <p className="text-[#FFFFFF] text-[18px] lg:text-[20px]">
                {testimonial.quote}
              </p>
            </div>
                <div className="mt-8 flex items-start gap-5">
                  <img
                    src={testimonial.image?.url}
                    alt={`${testimonial.name}'s profile`}
                    className="w-12 h-12 rounded-full"
                  />
                  <div className="flex flex-col gap-1">
                    <p className="text-[#FFFFFF] text-[18px] lg:text-[20px] font-semibold">
                      {testimonial.name}
                    </p>
                    <p className="text-[#929292] text-[14px] lg:text-[16px] font-thin">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </li>
            </SwiperSlide>
          ))}
        </Swiper>
      </ul>

      <div className="relative flex justify-center gap-5 mt-12 lg:mt-0 lg:hidden">
        <button
          onClick={handlePrev}
          className="p-2 bg-[#ADD143] rounded-lg px-4 py-4 lg:mx-0 lg:absolute lg:top-[500px] lg:right-[520px]"
        >
          <IoArrowBack size={24} />
        </button>
        <button
          onClick={handleNext}
          className="p-2 bg-[#ADD143] rounded-lg px-4 py-4 lg:mx-0 lg:absolute lg:top-[500px] lg:right-[440px]"
        >
          <IoArrowForward size={24} />
        </button>
      </div>
    </section>
  );
};

export default TestimonialContents;
